import React from 'react';

import { NodeProps } from './shared';

export function ListItemNode({ children }: NodeProps) {
  return <li className="-ml-2 mb-2 pl-2">{children}</li>;
}
